/**
 * Shared domain enums (snake_case canonical values).
 */
import { z } from 'zod';

// ============================================================================
// School Division
// ============================================================================

export const SchoolDivision = z.enum([
  'boys',
  'girls',
  'preschool',
]);
export type SchoolDivision = z.infer<typeof SchoolDivision>;

// ============================================================================
// Grade Levels
// ============================================================================

export const GradeLevel = z.enum([
  'nursery',
  'pre_k',
  'kindergarten',
  'grade_1',
  'grade_2',
  'grade_3',
  'grade_4',
  'grade_5',
  'grade_6',
  'grade_7',
  'grade_8',
]);
export type GradeLevel = z.infer<typeof GradeLevel>;

// ============================================================================
// Staff Role / Status
// ============================================================================

export const StaffRole = z.enum([
  'super-administrator',
  'admin',
  'principal',
  'teacher',
  'nurse',
  'accounts',
]);
export type StaffRole = z.infer<typeof StaffRole>;

export const StaffStatus = z.enum([
  'active',
  'invited',
  'deactivated',
]);
export type StaffStatus = z.infer<typeof StaffStatus>;

// ============================================================================
// Priority
// ============================================================================

export const Priority = z.enum([
  'normal',
  'urgent',
]);
export type Priority = z.infer<typeof Priority>;

// ============================================================================
// Integration Status
// ============================================================================

export const IntegrationStatusState = z.enum([
  'unknown',
  'connected',
  'disconnected',
  'error',
  'paused',
]);
export type IntegrationStatusState = z.infer<typeof IntegrationStatusState>;

// ============================================================================
// Enrollment Period Status
// ============================================================================

export const EnrollmentPeriodStatus = z.enum([
  'coming_soon',
  'open',
  'closed',
]);
export type EnrollmentPeriodStatus = z.infer<typeof EnrollmentPeriodStatus>;

// ============================================================================
// Notification Domain
// ============================================================================

export const NotificationSource = z.enum([
  'portal_message',
  'admissions',
  'financial_aid',
  'settings',
  'faculty',
  'students_families',
  'assistant',
  'system',
]);
export type NotificationSource = z.infer<typeof NotificationSource>;

export const NotificationPriority = z.enum([
  'low',
  'normal',
  'high',
  'urgent',
]);
export type NotificationPriority = z.infer<typeof NotificationPriority>;

export const NotificationCategory = z.enum([
  'message',
  'application',
  'attendance',
  'academic',
  'announcements',
  'financial_aid',
  'settings',
  'faculty',
  'student_family',
  'deadline',
  'assistant',
  'system',
]);
export type NotificationCategory = z.infer<typeof NotificationCategory>;

export const NotificationDeliveryState = z.enum([
  'unread',
  'read',
  'archived',
]);
export type NotificationDeliveryState = z.infer<typeof NotificationDeliveryState>;
